import constants from 'constants/constants';
import moment from 'moment-timezone';

import classes from 'components/Dashboards/Project/Components/VersionCompare/TableTab/tabs.module.scss';

const TableTab = ({ data }) => {
    return (
        <div className={classes.tab}>
            <div className={classes.title}>{data.summary.title}</div>
            <div className={classes.subTitle}>
                {moment(data.summary.startDate).format(constants.formats.date.default)} -{' '}
                {moment(data.summary.endDate).format(constants.formats.date.default)} total {data.summary.items} changes
                ({data.summary.percent}%)
            </div>
        </div>
    );
};
export default TableTab;
